import React from 'react';
import './style.css';
import Inspector from '../../inspector/Inspector';

const EditorTabPanelInspector = ({ /* props */ }) => {
    return (
        <div className="inspector-tab-scroll" data-scroll-root>
            <Inspector/>
        </div>
    );
};

export default EditorTabPanelInspector;
